import React from 'react'
import { TextField } from '@material-ui/core'

type TextAreaProps = {
  label?: string
  placeholder?: string
  value: string
  variant?: any
  rows: number
  fullWidth?: boolean
  required?: boolean
  inputHandler: (input: string) => void
  error?: boolean
  helperText?: string
}

const TextArea: React.FC<TextAreaProps> = ({
  label = '',
  placeholder,
  value,
  rows,
  variant,
  fullWidth,
  required = false,
  inputHandler,
  error = false,
  helperText = ''
}) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={value}
      multiline
      rows={rows}
      variant={variant}
      fullWidth={fullWidth}
      onChange={event => inputHandler(event.target.value)}
      required={required}
      error={error}
      helperText={helperText}
    />
  )
}

export default TextArea
